import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Confetti from 'react-confetti';

const TheatricalResults = ({ children }) => {
	const [showResults, setShowResults] = useState(false);
	const [showConfetti, setShowConfetti] = useState(false);
	const [windowDimension, setWindowDimension] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	// Detect window dimensions
	useEffect(() => {
		const handleResize = () => {
			setWindowDimension({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// Simplified animation sequence
	useEffect(() => {
		// Show results after a brief delay
		const resultsTimer = setTimeout(() => {
			setShowResults(true);

			// Show confetti shortly after the results
			const confettiTimer = setTimeout(() => {
				setShowConfetti(true);

				// Hide confetti after 5 seconds
				const hideConfettiTimer = setTimeout(() => {
					setShowConfetti(false);
				}, 5000);

				return () => clearTimeout(hideConfettiTimer);
			}, 500);

			return () => clearTimeout(confettiTimer);
		}, 500);

		return () => clearTimeout(resultsTimer);
	}, []);

	return (
		<div className='theatrical-container relative w-full h-full' style={{ background: 'transparent' }}>
			{/* Results container with fade-in animation */}
			<motion.div
				className='content-container relative z-20 w-full h-full flex items-center justify-center'
				style={{ background: 'transparent' }}
				initial={{ opacity: 0, scale: 0.8 }}
				animate={{
					opacity: showResults ? 1 : 0,
					scale: showResults ? 1 : 0.8,
				}}
				transition={{ duration: 0.8, ease: 'easeOut' }}
			>
				{/* Soft spotlight effect */}
				<div
					className='spotlight absolute inset-0'
					style={{
						background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0) 70%)',
						transform: 'scale(1.5)',
						pointerEvents: 'none',
					}}
				/>

				{/* Results content */}
				<div className='results-content w-full max-w-4xl mx-auto'>{children}</div>
			</motion.div>

			{/* Confetti - always on top layer */}
			{showConfetti && (
				<div className='confetti-container absolute inset-0 z-30 pointer-events-none'>
					<Confetti
						width={windowDimension.width}
						height={windowDimension.height}
						recycle={false}
						numberOfPieces={300}
						gravity={0.15}
						colors={[
							'#FFD700', // Bright gold
							'#FF1493', // Hot pink
							'#00FFFF', // Cyan
							'#FF4500', // Orange-red
							'#32CD32', // Lime green
							'#FF00FF', // Magenta
							'#1E90FF', // Bright blue
							'#FFFF00', // Bright yellow
						]}
						opacity={1.0}
					/>
				</div>
			)}
		</div>
	);
};

export default TheatricalResults;
